import { MutableRefObject, useEffect } from 'react'

export const useClickOutside = (
    ref: MutableRefObject<null | HTMLElement>,
    callback: () => void,
) => {
    useEffect(() => {
        const handler = ({ target }: MouseEvent) => {
            if (target instanceof Node && !ref.current?.contains(target)) {
                callback()
            }
        }
        document.addEventListener('mousedown', handler)
        return () => document.removeEventListener('mousedown', handler)
    }, [callback, ref])
}
